<app-dialog-heading [heading]="'Payments'"></app-dialog-heading>

  <ng-container *ngIf="isDataExist; else noPayments">
    
    <!---------------------------->
    <!-- Payments Table:-->
    <!---------------------------->
    
    <div class="mat-elevation-z8 table-container">
      <table class="w-100" mat-table matSort multiTemplateDataRows
             [dataSource]="paymentDataSource"
             #MatSortPaymentOverview="matSort">
        
        <ng-container [matColumnDef]="TableColumns.PaymentId">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
          <td *matCellDef="let row" mat-cell> {{row.paymentId}}</td>
        </ng-container>
        
        <ng-container [matColumnDef]="TableColumns.PreAuthorisationPayment">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Upfront</th>
          <td *matCellDef="let row" mat-cell> {{isPreAuthorisationPayment(row) ? 'Y' : 'N'}}</td>
        </ng-container>
        
        
        <ng-container [matColumnDef]="TableColumns.PaymentReference">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Reference</th>
          <td *matCellDef="let row" mat-cell>
            <div class="flex justify-start items-baseline">
              <app-open-link-as [icon]="DisplayIcon.DialogIcon" (onClick)="openPaymentDialog($event, row)"></app-open-link-as>
              <p>{{row.paymentReference == null || row.paymentReference.trim() === '' ? 'update reference' : row.paymentReference}}</p>
            </div>
          </td>
        </ng-container>
        
        <ng-container [matColumnDef]="TableColumns.PaymentExecutionDate">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Execution Date</th>
          <td *matCellDef="let row" mat-cell> {{row.paymentExecutionDate | date: dateFormat}}</td>
        </ng-container>
        
        <ng-container [matColumnDef]="TableColumns.PaymentCompletionDate">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Reference Completion Date</th>
          <td *matCellDef="let row" mat-cell> {{row.paymentCompletionDate | date: dateFormat}}</td>
        </ng-container>
        
        
        <ng-container [matColumnDef]="TableColumns.Amount">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Amount</th>
          <td *matCellDef="let row" mat-cell> {{row.amount | number: '.2'}}</td>
        </ng-container>
        
        <ng-container matColumnDef="expandedDetail">
          <td *matCellDef="let row" mat-cell [attr.colspan]="paymentDisplayedColumns.length">
            <div class="row-detail-container" [@detailExpand]="row == paymentExpandedRow ? 'expanded' : 'collapsed'">
              <b>Created By: </b>{{row.createdBy}}<br>
              <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
              <b>Updated By: </b>{{row.updatedBy}}<br>
              <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
            </div>
          </td>
        </ng-container>
        
        <tr mat-header-row *matHeaderRowDef="paymentDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: paymentDisplayedColumns;" class="row"
            [class.expanded-row]="paymentExpandedRow == row"
            (click)="paymentExpandedRow = paymentExpandedRow === row ? null : row"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
      </table>
      
      <mat-paginator #MatPaginatorPaymentOverview="matPaginator"
                     [pageIndex]="0"
                     [length]="paymentTableControl.length"
                     [pageSize]="paymentTableControl.pageSize"
                     [pageSizeOptions]="paymentTableControl.pageSizeOptions">
      </mat-paginator>
    
    </div>
  </ng-container>
  
  <ng-template #noPayments>
    <div class="text-center mat-primary-color">
      <label class="column-label claim-column-label">No payment data</label>
    </div>
  </ng-template>

